var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-card-content"},[_c('h2',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.text)?_c('p',{staticClass:"widget-card-description"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }